'use strict';

angular.module('atex.dam').directive('damMetadataTagDimension', function(MetadataService, $compile, $timeout) {
  
  var closeVisiblePopovers = function(popoverIdToKeep) {
    $('.popover:visible').each(function(index, element) {
      // Don't close the dam-search-form popover
      if($(element).find('.dam-search-form').length === 0) {
        var popoverId = $(element) ? $(element).attr('id') : "";
        if (popoverId !== popoverIdToKeep) {
          $(element).data('bs.popover').$element.popover('hide');
        }
      }
    });
  };
  
  var cleanEntity = function(entity) {
    delete entity['children-omitted'];
    (entity.entities || []).forEach(cleanEntity);
  };
  
  return {
    require: '^ngModel',
    scope: {
      model: '=ngModel',
      label: '='
    },

    controller: function($scope) {
      $scope.destroyed = false;
    },

    link: function(scope, element, attr, ngModel) {
      
      var dimensionId = attr.dimensionId;

      var enumerable = scope.$eval(attr.enumerable) !== false; // default value: true
      var editable = scope.$eval(attr.editable) !== false; // default value: true

      var entityResolvePromises = {};

      var isSearchTermOK = function(term) {
        return term.split(/\//).every(function(part) { return part.trim().length >= 2; }) &&
          typeof _.find(term.split(/\s+/), function(s) { return s.trim().length >= 2; }) !== 'undefined';
      };

      element.select2({
        tags: function() {
          return [];
        },
        placeholder: scope.label,
        
        separator: '|',
        tokenSeparators: enumerable === true ? undefined : [","],
        containerCss: { "width": "100%" },
        containerCssClass: "metadata-tags",
        selectOnBlur: true,

        formatNoMatches: function(term) {
          return !isSearchTermOK(term) ? 'Please enter 2 or more characters' : 'No matches found';
        },

        formatSelection: function(object, container) {
          var entityPath = atex.dam.AngularUtils.entityToPath(object);
          return entityPath;
        },

        formatResult: function(entity, container, query) {
          var entityPath = atex.dam.AngularUtils.entityToPath(entity);
          var split = _.uniq(query.term.trim().replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&").split(/\s+|\//));

          var regex = _.sortBy(split, function(s) { return -s.length; }).join('|');

          var lastIndexOfSlash = entityPath.lastIndexOf('/');

          var leafString = lastIndexOfSlash === -1 ? entityPath : entityPath.substring(lastIndexOfSlash + 1);
          leafString = leafString.replace(new RegExp(regex, 'ig'), '<strong>$&</strong>');

          return lastIndexOfSlash === -1 ? leafString : (entityPath.substring(0, lastIndexOfSlash + 1) + leafString);
        },

        query: _.debounce(function(options) {
          if (isSearchTermOK(options.term) && options.term.length > 1) {
            MetadataService.getSuggestions({
              dimensionId: dimensionId,
              entityString: options.term
            }).then(function(result) {
              var entities = result.data.entities.map(function(entity) {
                cleanEntity(entity);
                return entity;
              });
              options.callback({ more: false, results: entities });
            }).then(undefined, function(error) {
              console.log('Error while autocompleting in dimension ' + dimensionId + '!', error);
              options.callback({ more: false, results: [] });
            });
          } else {
            options.callback({ more: false, results: [] });
          }
        }, 200),

        id: function(object) {
          return atex.dam.AngularUtils.entityToPath(object);
        }
      });

      // The input field is difficult to focus on tablets. This is a fix.
      element.select2('container').find('.select2-choices').click(function() {
        $('.select2-search-field input', this).focus();
        var focusedElement = $(this).find('.select2-search-choice-focus .popover-trigger');

        if (focusedElement.length === 0) {
          closeVisiblePopovers();
        } else {
          var popoverInstance = focusedElement.data("bs.popover");
          var toRemainOpen = popoverInstance.$tip ? popoverInstance.$tip.attr("id") : "";
          closeVisiblePopovers(toRemainOpen);
        }
      });

      if (!editable) {
        element.select2('readonly', true);
      }

      scope.$watch('model', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          closeVisiblePopovers();
        }
      }, true);

      scope.$watch('label', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          element.attr('data-placeholder', scope.label);
        }
      });
        
      ngModel.$render = function(value) {
        element.select2('data', ngModel.$viewValue);
      };

      element.on('select2-removing', function(event) {
        closeVisiblePopovers();
      });

      element.on('change', function(event) {
        closeVisiblePopovers();

        scope.$apply(function() {
          ngModel.$setViewValue(element.select2('data'));
        });
      });

      scope.$on('$destroy', function() {
        scope.destroyed = true;
      });
      
    }
  };
});

angular.module('atex.dam').directive('damMetadataField', function(MetadataService) {
  
  var fromEntityPathArrayToEntities = function(entityPathArray) {
    var entities = [];
    angular.forEach(entityPathArray, function(entityPath, key) {
      var entity = atex.dam.AngularUtils.entityFromPath(entityPath);
      entities.push(entity);
    });
    return entities;
  };
  
  var fromEntitiesToEntityPathArray = function(entities) {
    var entityPathArray = [];
    angular.forEach(entities, function(entity, key) {
      var entityPath = atex.dam.AngularUtils.entityToPath(entity);
      entityPathArray.push(entityPath);
    });
    return entityPathArray;
  };
  
  return {
      
    scope: {
      label : "@",
      entries : "="
    },

    templateUrl : 'js/dam/widgets/dam-metadata-field/dam-metadata-field.html',
    
    link: function(scope, element, attr) {
      
      scope.loaded = false;
      scope.dimensionInfo = {};
      scope.dimensionInfo.model = fromEntityPathArrayToEntities(scope.entries);
      
      MetadataService.getStructure({ id: attr.metadataTagId }).then(function(response) {
        scope.dimensionInfo.dimension = response.data;
        scope.loaded = true;
      });
      
      scope.$watch('dimensionInfo.model', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.entries = fromEntitiesToEntityPathArray(newValue);
        }
      }, true);
      
      scope.$watch('entries', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.dimensionInfo.model = fromEntityPathArrayToEntities(scope.entries);
        }
      }, true);
    }
    
  };
  
} );
